import React, { useEffect, useRef } from 'react';
import CardCommon from '@op/components/CardCommon';
import { DefaultImg } from '@op/constants/defaultImg';
import EventCardList from './EventCardList';
import AISummaryCard from './AISummaryCard';
import useLanguage from '@op/hooks/useLanguage';
import './index.scss';
import SvgIcon from '@home/components/SvgIcon';
import { useHistory } from 'umi';
import useSummaryEvent from '../../hooks/useSummaryEvent';
import { DBO_TM, DBO_U } from '@op/utils/format';
import classNames from 'classnames';
import BubbleCommon from '@op/components/BubbleCommon';

type ModeType = 'events' | 'ai';

interface IAISummaryEvents {
  expanded: boolean;
  mode?: ModeType;
  filter?: any;
  gameInfo: any;
  wholeGameInfo?: any;
  channelType?: string;
  isSteam?: boolean;
  onHasDataChange?: (hasData: boolean) => void;
  setSummaryBtnLoading?: (loading: boolean) => void;
}

export default function AISummaryEvents({
  expanded,
  mode = 'events',
  filter,
  gameInfo,
  wholeGameInfo,
  channelType = 'total',
  isSteam = false,
  onHasDataChange,
  setSummaryBtnLoading,
}: IAISummaryEvents) {
  const { formatMessage } = useLanguage();
  const summaryRef = useRef(null);
  const history = useHistory();

  const {
    loading,
    hasEventStats,
    sentimentGroups,
    hasData,
    summaryData,
    tipsMap,
  } = useSummaryEvent({
    filter,
    gameInfo,
    channelType,
  });

  // Notify parent about hasData changes
  useEffect(() => {
    onHasDataChange?.(hasData);
    // loading 结束后（hasData=true 有数据 / loading=false 且 hasData=false 无数据），停止按钮 loading
    if (!loading) {
      setSummaryBtnLoading?.(false);
    }
  }, [hasData, loading]);

  if (loading || !hasData) return null;

  return (
    <CardCommon
      className={classNames('dbo-ai-summary-events', { 'dbo-ai-summary-events--hidden': !expanded })}
      hasTitleArrow={hasEventStats}
      dropdownsFilterBeforeElement={
        <span
          className="dbo-ai-summary-events__goto-link"
          onClick={(e) => {
            e.stopPropagation();
            DBO_U.go({
              path: `/opinion/Overview/KeyOpinions`,
              params: filter,
            });
          }}
        >
          {formatMessage({ id: 'Go to Key Opinions AI Analysis' })}
          <SvgIcon type="arrow-right" className="card-slot-icon" />
        </span>
      }
      title={
        <div
          className="dbo-card-title-info"
          onClick={(e) => {
            e.stopPropagation();
            if (!hasEventStats) {
              return;
            }
            history.push('/opinion/Summary/HotEvent');
          }}
        >
          <img
            src={DefaultImg.AI}
            className="dbo-ai-summary-events__title-icon"
          />
          {formatMessage({ id: 'AI Opinions Summary' })}
          <div className="dbo-card-title-info-desc">
            ({summaryData?.data_date ? DBO_TM.sFormat(summaryData?.data_date) : DBO_TM.timeTitle(filter)})
          </div>
          {
            tipsMap && (
              <BubbleCommon tipsMap={tipsMap} />
            )
          }
        </div>
      }

    >
      {mode === 'events' && (
        <EventCardList
          hasEventStats={hasEventStats}
          sentimentGroups={sentimentGroups}
          loading={loading}
          filter={filter}
          gameInfo={gameInfo}
          channelType={channelType}
          summaryData={summaryData}
        />
      )}
      {mode === 'ai' && (
        <AISummaryCard
          filter={filter}
          pageCardRef={summaryRef}
          wholeGameInfo={wholeGameInfo}
          channelOption={channelType}
          isSteam={isSteam}
          reportData={summaryData}
        />
      )}
    </CardCommon>
  );
}
